import { Card, Typography, Button, Input } from "antd";
import { useState } from "react";
import Btncom from "../Components/Btncom";
import { toast } from "react-toastify";
import reapi from "../apis/reapi";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function VerifyOtp({ form }) {
    const [otp, setOtp] = useState("");
    const [loading, setloading] = useState(false);
    console.log(form)
    const navigate = useNavigate()


    const verifyOtp = async () => {
        setloading(true)
        try {
            if (otp.length == 4) {

                await reapi.post(`/verify-signup-otp`, { otp, ...form }).then((res) => {
                    if (res?.data.status) {
                        console.log(res.data)
                        toast.success(res?.data.message)
                         localStorage.setItem('token', res.data?.data.token);
                         localStorage.setItem('userInfo', JSON.stringify(res.data?.data.user));
                         navigate(`/`)
                    window.location.reload(``)
                    } else {
                        toast.error(res?.data.message)

                    }
                }).catch((e) => {

                    toast.error(e?.response?.data.message)

                })

            } else {
                toast.error('Please Fill 4-Digit OTP')

            }

        } catch (error) {
            toast.error('Some error')
        }
        setloading(false)


    };


    const handleresendotp = () => {
        console.log(otp);
    };



    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#faf8f5",
            }}
        >
            <Card
                style={{
                    width: 420,
                    borderRadius: 20,
                    boxShadow:
                        "0 10px 30px rgba(0,0,0,0.08)",
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <img
                        src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png" width={150} style={{ textAlign: 'center', display: 'unset' }}
                        alt="ShipLess"

                    />

                    <Title level={2}>
                        Verify OTP
                    </Title>

                    <Text type="secondary">
                        Enter the OTP sent to your
                        mobile number
                    </Text>
                </div>

                <div
                    style={{
                        marginTop: 30,
                        textAlign: 'center'
                    }}
                >
                    <Input.OTP
                        length={4}
                        value={otp}
                        onChange={setOtp}
                        type="number"
                        size="large"
                    />

                    <Button
                        loading={loading}
                        type="primary"
                        block
                        size="large"
                        style={{
                            marginTop: 25,
                            height: 48,
                            background: "#ff6b00",
                            borderColor: "#ff6b00",
                        }}
                        onClick={verifyOtp}
                    >
                        Verify OTP
                    </Button>

                    <div
                        style={{
                            textAlign: "center",
                            marginTop: 15,
                        }}
                    >
                        {/* <Button onClick={handleresendotp} type="link">
                            Resend OTP
                        </Button> */}
                    </div>
                </div>
            </Card>
        </div>
    );
}